import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const DepositList = () => {
  const location = useLocation();
  const [depositData, setDepositData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);

    try {
      const res = await Http.get(`/accounts/deposits`);
      const resRole = await Http.get(`/staff-type-check`);
      setDepositData(res.data);
      setRole(resRole.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const cols = [
    { field: "bank.name", header: "Bank" },
    { field: "amount", header: "Amount" },
    { field: "date", header: "Date" },
    { field: "counter_no", header: "Counter No" },
    { field: "reference", header: "Reference" },
    { field: "created_by.name", header: "Created By" }
  ];

  const actionTemplate = (item) => {
    return (
      <td className="text-xs text-center">
        <Link
          to={`/view-deposit/${item.id}`}
          className="btn btn-info btn-sm ms-1"
          title="View Deposit"
        >
          <i className="fa fa-list" aria-hidden="true"></i>
        </Link>
        {(role === "admin" || role === "supply_chain") && (
          <Link
            to={`/edit-deposit/${item.id}`}
            className="btn btn-primary btn-sm ml-1"
            title="Edit"
          >
            <i className="fa fa-pencil" aria-hidden="true"></i>
          </Link>
        )}
      </td>
    );
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <span
        className={`badge ${
          rowData.status === "active" ? "badge-success" : "badge-danger"
        }`}
      >
        {rowData.status === "active" ? "Active" : "Inactive"}
      </span>
    );
  };

  const amountBodyTemplate = (rowData) => {
    return <span>{rowData.amount}</span>;
  };

  const dateBodyTemplate = (rowData) => {
    return <span>{new Date(rowData.date).toLocaleDateString()}</span>;
  };

  // const header = renderHeader();

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Deposits</h5>
            <div className="am-right">
              {(role === "admin" || role === "supply_chain") && (
                <Link
                  to="/create-deposit"
                  className="btn btn-primary"
                >
                  <i className="fa fa-plus"></i> Add New Deposit
                </Link>
              )}
            </div>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={depositData}
                isLoading={loading}
                actionTemplate={actionTemplate}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositList;